import { createContext, useContext } from "react";

const RowIndexContext = createContext<number>(-1);

export const RowIndexProvider = RowIndexContext.Provider;

export function useRowIndex(): number {
  return useContext(RowIndexContext);
}
